<mat-card>

  <mat-card-header>
    <mat-card-title>Comprobantes de Expensas</mat-card-title>
    <mat-card-subtitle></mat-card-subtitle>
  </mat-card-header>

  <mat-card-content>

    <div mat-dialog-content style="margin: 15px 0px; text-align: center;">

      <mat-label *ngIf="isValidating"><i class="fa fa-spinner fa-spin"></i> Cargando...</mat-label>
      <mat-label *ngIf="!isValidating && msgError.length > 0">{{msgError}}</mat-label>

    </div>

    <div mat-dialog-content *ngIf="isValid">

      <ng-container *ngIf="item != null && item.TenantNombre != null && item.TenantNombre.length > 0">

        <mat-expansion-panel [expanded]="true" hideToggle="true">

          <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly" style="margin-top: 20px;">
      
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label class="text-style"><b>{{item.TenantTraduccion}}</b>: {{item.TenantNombre}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label class="text-style"><b>{{item.ComunidadTraduccion}}</b>: {{item.ComunidadNombre}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label class="text-style"><b>Período Expensa</b>: {{item.ExpensaPeriodo}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div> 

          </div>

        </mat-expansion-panel>

        <br/>

      </ng-container>

      <mat-expansion-panel [expanded]="true" hideToggle="true">

        <div fxLayout="row stretch" fxLayout.xs="column" style="margin-top: 10px;">

          <ejs-grid #grid [dataSource]='item?.Items' [allowPaging]="false" [allowSorting]="true" [toolbar]='toolbarOptions'
            [pageSettings]='pageSettings' [allowResizing]='true'>
            <e-columns>
              <e-column headerText='' width=50>
                <ng-template #template let-data>
                  <a style="cursor: pointer;" href="{{data.AdjuntoUrl}}" target="_blank" title="Ver/Descargar archivo">
                    <!-- <i class="fa fa-file fa-1x"></i> --> Ver
                  </a>
                </ng-template>
              </e-column>
              <e-column field='AdjuntoNombre' headerText='Archivo'></e-column>
            </e-columns>
          </ejs-grid>

        </div>

      </mat-expansion-panel>

      <br/>

    </div>

    <div mat-dialog-actions align="center">
      <div fxLayout="row stretch" fxLayout.xs="column" fxLayoutAlign="center center">
        <button mat-raised-button color="warn" (click)="onCancelar()" class="zb-button">
          <mat-icon style="margin-right: 5px;">cancel</mat-icon>{{isValid ? 'Cerrar' : 'Ir a Inicio'}}
        </button>
      </div>
    </div>

  </mat-card-content>

</mat-card>